interface LogoProps {
  size?: number
  className?: string
}

export function Logo({ size = 28, className = '' }: LogoProps) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <linearGradient id="logoBg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#fb923c"/>
          <stop offset="50%" stopColor="#f97316"/>
          <stop offset="100%" stopColor="#ea580c"/>
        </linearGradient>
        <linearGradient id="logoShine" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(255,255,255,0.3)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </linearGradient>
        <linearGradient id="logoPage" x1="0" y1="0" x2="0.3" y2="1">
          <stop offset="0%" stopColor="white"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0.85)"/>
        </linearGradient>
        <linearGradient id="logoSpark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#fbbf24"/>
          <stop offset="100%" stopColor="#f59e0b"/>
        </linearGradient>
      </defs>

      {/* Rounded square */}
      <rect x="16" y="16" width="480" height="480" rx="108" fill="url(#logoBg)"/>
      <rect x="16" y="16" width="480" height="240" rx="108" fill="url(#logoShine)" opacity="0.4"/>

      {/* Book - left page */}
      <path d="M256 148C256 148 196 140 148 152L148 368C196 356 256 364 256 364Z" fill="url(#logoPage)" opacity="0.95"/>
      {/* Book - right page */}
      <path d="M256 148C256 148 316 140 364 152L364 368C316 356 256 364 256 364Z" fill="url(#logoPage)" opacity="0.88"/>

      {/* Spine */}
      <line x1="256" y1="148" x2="256" y2="364" stroke="rgba(249,115,22,0.4)" strokeWidth="2"/>

      {/* Left page lines */}
      <line x1="172" y1="200" x2="238" y2="194" stroke="rgba(0,0,0,0.08)" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="172" y1="228" x2="238" y2="222" stroke="rgba(0,0,0,0.08)" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="172" y1="256" x2="238" y2="250" stroke="rgba(0,0,0,0.08)" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="172" y1="284" x2="218" y2="280" stroke="rgba(0,0,0,0.06)" strokeWidth="2.5" strokeLinecap="round"/>

      {/* Sparkle - main */}
      <path d="M340 130L344 142L356 146L344 150L340 162L336 150L324 146L336 142Z" fill="url(#logoSpark)"/>
      {/* Sparkle - medium */}
      <path d="M372 172L374 178L380 180L374 182L372 188L370 182L364 180L370 178Z" fill="#fbbf24" opacity="0.7"/>
      {/* Sparkle - small */}
      <path d="M320 110L321.5 114.5L326 116L321.5 117.5L320 122L318.5 117.5L314 116L318.5 114.5Z" fill="#fcd34d" opacity="0.5"/>

      {/* Neural nodes */}
      <circle cx="290" cy="210" r="5" fill="rgba(249,115,22,0.5)"/>
      <circle cx="320" cy="240" r="5" fill="rgba(249,115,22,0.4)"/>
      <circle cx="300" cy="280" r="5" fill="rgba(249,115,22,0.35)"/>
      <circle cx="332" cy="300" r="4" fill="rgba(249,115,22,0.3)"/>
      <circle cx="280" cy="330" r="4" fill="rgba(249,115,22,0.25)"/>

      {/* Neural connections */}
      <line x1="290" y1="210" x2="320" y2="240" stroke="rgba(249,115,22,0.25)" strokeWidth="1.5"/>
      <line x1="320" y1="240" x2="300" y2="280" stroke="rgba(249,115,22,0.2)" strokeWidth="1.5"/>
      <line x1="300" y1="280" x2="332" y2="300" stroke="rgba(249,115,22,0.18)" strokeWidth="1.5"/>
      <line x1="300" y1="280" x2="280" y2="330" stroke="rgba(249,115,22,0.15)" strokeWidth="1.5"/>
      <line x1="332" y1="300" x2="280" y2="330" stroke="rgba(249,115,22,0.15)" strokeWidth="1.5"/>
    </svg>
  )
}
